import { render, staticRenderFns } from "./RoundCardPosition.vue?vue&type=template&id=d5ccaa72&scoped=true&"
import script from "./RoundCardPosition.vue?vue&type=script&lang=ts&"
export * from "./RoundCardPosition.vue?vue&type=script&lang=ts&"
import style0 from "./RoundCardPosition.vue?vue&type=style&index=0&id=d5ccaa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ccaa72",
  null
  
)

export default component.exports